// extracted by mini-css-extract-plugin
module.exports = {"container":"Text_container__1iM45","toolbar":"Text_toolbar__1AE-U","toolbarButton":"Text_toolbarButton__K6WFv","editor":"Text_editor__2221d","flex1":"Text_flex1__3-IUu"};